import Lesson from 'pages/lessons/components/lesson';
import './index.scss';

(function ($) {
  // Solução temporária
  const browserIsChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor); 
  const collapsibleSubjects = $('.js-subject-list .js-collapsible-content');

  if (browserIsChrome) {
    collapsibleSubjects.collapse('show');
  } else {
    collapsibleSubjects.first().collapse('show');
  }
  
  $('.js-lesson', '.js-subject-list').each((i, el) => {
    new Lesson($(el));
  });
})(jQuery);
